<script setup lang="ts">
import type { ICreditPurposes } from '~/components/widget/select-credit-purpose'
import type { IResponseData } from '~/types'
import type { IProps } from '~/components/entity/credit'
const props = defineProps<IProps>()
const url = computed(() => useUrlWithParams('/credit_purposes', { ...props.queryParams }))
const { data } = useApi<IResponseData<ICreditPurposes[]>>(() => url, {
  key: 'credit-purposes-sidebar-widget'
})
const creditPurposes = computed(() => {
  return data.value?.data.map((i) => {
    return {
      title: i.title,
      url: `/credits/purpose/${i.slug}`,
      icon: i.slug
    }
  })
})
</script>

<template>
  <SidebarBlock
    v-if="creditPurposes?.length"
    :heading-text="$t('common.credit_purpose')"
    variant="white"
  >
    <SidebarMenu :menu-items="creditPurposes" />
  </SidebarBlock>
</template>
